import { LoadingMessage, LocaleDictionaryType } from "@/lib/main";
import { CSSProperties } from "react";

type Props = {
  message: LocaleDictionaryType;
};

export default function FullScreenSuspenseFallback({ message }: Props) {
  const supportsDynamicViewportUnits =
    typeof CSS !== "undefined" && CSS.supports("height", "100dvh");

  const styles: CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    height: supportsDynamicViewportUnits ? "100dvh" : "100vh",
    width: "100%",
  };

  return (
    <div style={styles}>
      <LoadingMessage message={message} />
    </div>
  );
}
